var map = {
	"./alert8.png": 5907,
	"./charity.png": 6193,
	"./contact.jpg": 9545,
	"./guide1.jpg": 8374,
	"./guide10.jpg": 826,
	"./guide11.jpg": 9640,
	"./guide111.jpg": 611,
	"./guide12.jpg": 3167,
	"./guide13.jpg": 8437,
	"./guide14.jpg": 2857,
	"./guide15.jpg": 8811,
	"./guide16.jpg": 8587,
	"./guide17.jpg": 2047,
	"./guide18.jpg": 7294,
	"./guide19.jpg": 9026,
	"./guide2.jpg": 5856,
	"./guide3.jpg": 9911,
	"./guide4.jpg": 6406,
	"./guide5.jpg": 7465,
	"./guide6.jpg": 1045,
	"./guide7.jpg": 7997,
	"./guide8.jpg": 4511,
	"./guide9.jpg": 2550,
	"./recycle-bin.png": 4952,
	"./recycle-bin1.png": 267,
	"./recycle-bin2.png": 8523,
	"./recycle10.png": 1252,
	"./score.png": 9019,
	"./trash-2.jpg": 9633,
	"./trash-3.jpg": 6404,
	"./trash-4.jpg": 8997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1600;